

// src\components\main\widgets\AnimatedSection.tsx
'use client';

import { motion } from 'motion/react';
import { ReactNode } from 'react';
import { cn } from '@/core/lib/utils';

interface AnimatedSectionProps {
    children: ReactNode;
    className?: string;
}

export default function AnimatedSection({ children, className }: AnimatedSectionProps) {
    return (
        <motion.section
            className={cn('w-full', className)}
            initial={{ opacity: 0, y: 12, scale: 0.995 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: false, amount: 0.2, margin: '-10% 0px -10% 0px' }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.section>
    );
}
